import { Component, Input } from '@angular/core';
import { MatCardModule } from '@angular/material/card';
import { PriorAuthQueueComponent } from '../../prior-auth-queue/prior-auth-queue.component';
import { DraftEformsQueueComponent } from '../../eform-queues/draft-eforms-queue/draft-eforms-queue.component';
import { SubmittedEformsQueueComponent } from '../../eform-queues/submitted-eforms-queue/submitted-eforms-queue.component';
import { MatTabsModule } from '@angular/material/tabs';

@Component({
  selector: 'app-third-party-administrator-dashboard',
  templateUrl: './third-party-administrator-dashboard.component.html',
  styleUrls: ['./third-party-administrator-dashboard.component.scss'],
  imports: [
    MatCardModule,
    MatTabsModule,
    PriorAuthQueueComponent,
    DraftEformsQueueComponent,
    SubmittedEformsQueueComponent,
  ],
})
export class ThirdPartyAdministratorDashboardComponent {
  selectedTabIndex: number;
  @Input() redirectToTabIndex: number;
}
